import React from 'react';

const Regulatory = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        We comply with:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>GDPR (General Data Protection Regulation)</li>
        <li>CCPA (California Consumer Privacy Act)</li>
        <li>HIPAA (Health Insurance Portability and Accountability Act)</li>
        <li>Other applicable privacy regulations</li>
      </ul>
    </div>
  );
};

export default Regulatory;